"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Mega Matcher ID management
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2024.2.0
 * Contact: support@neurotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateSubjectRequestOption = exports.CreateSubjectRequestModality = void 0;
exports.CreateSubjectRequestModality = {
    FaceModality: 'FACE_MODALITY',
    VoiceModality: 'VOICE_MODALITY',
    FingersLeftHandModality: 'FINGERS_LEFT_HAND_MODALITY',
    FingersRightHandModality: 'FINGERS_RIGHT_HAND_MODALITY',
    Unrecognized: 'UNRECOGNIZED'
};
exports.CreateSubjectRequestOption = {
    Image: 'IMAGE',
    Audio: 'AUDIO',
    NTemplate: 'N_TEMPLATE',
    MmidTemplate: 'MMID_TEMPLATE'
};
